import BaseApiAction from '@Actions/base-api-action';

export default class SecureSetUserDisabled extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'secure-secureSetUserDisabled',
      payload: {
        auth_id: this._payload.auth_id,
        user_id: this._payload.user_id,
        disabled: this._payload.disabled,
      },
    });
  }

  onSuccess(data) {
    if (this._payload.disabled) {
      this._state.admin.users.events.userDisabled.emit();
    } else {
      this._state.admin.users.events.userEnabled.emit();
    }
    super.onSuccess(data);
  }
}
